import styled from "@emotion/styled";

export const ButtonStyles = styled("div")`
  .button {
    width: 100%;
    height: 64px;
    border: 0;
    cursor: pointer;
    border-radius: 7px;
    background-color: #3333cc;
    color: #fff;

    &:hover {
      opacity: 0.9;
    }

    &:disabled,
    &[disabled] {
      cursor: default;
      opacity: 0.4;
    }

    &.--small {
      height: 36px;
    }
    &.--medium {
      height: 46px;
    }
    &.--big {
      height: 64px;
    }

    &.--outlined {
      border: 2px solid rgba(41, 51, 89, 0.1);
      color: #474747;
      background-color: unset;
      font-weight: 600;

      &:hover {
        background-color: rgba(41, 51, 89, 0.1);
      }
    }

    &.--filled {
      background-color: rgb(233, 235, 242);
      border-color: rgb(233, 235, 242);
    }
  }
`;
